import axiosInstance from "./AxiosInstance";


export function createVendor(data) {
    return axiosInstance.post("api/vendor", data);
}

export function getVendorList(page, pageSize, filter = {}, isExport = false) {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("page_size", pageSize);

  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });

  if (isExport) {
    params.append("export", "true");
    return axiosInstance.get(`api/vendor?${params.toString()}`, {
      responseType: "blob",
    });
  }

  return axiosInstance.get(`api/vendor?${params.toString()}`);
}

export function importVendors(file) {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post(`api/vendor/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}


export function updateVendor(vendorId, data) {
    return axiosInstance.put(`api/vendor/${vendorId}`, data);
}

export function getVendorData(vendorId) {
    return axiosInstance.get(`api/vendor/${vendorId}`)
}

export function getVendorAssetUnits(vendorId, param) {
    const params = new URLSearchParams(param)
    return axiosInstance.get(`api/vendor/units/${vendorId}?${params.toString()}`)
}

export function getVendorAssetsSummary(vendorId, param) {
  const params = new URLSearchParams(param);

  const isExport = params.get("export") === "true";

  return axiosInstance.get(`api/vendor/assets_summary/${vendorId}?${params}`, {
    responseType: isExport ? "blob" : "json",
  });
}
